module.exports = __webpack_public_path__ + "fd40f25ff9b43e83d53e71d97475e15b.png";